import { useShowChangePasswordPage } from 'shared/hooks/use-show-change-password-page'
import useUser from 'shared/hooks/use-user'
import { SettingsMenuEnum } from '../enums/settings-menu-enum'
import { isSioHost } from '@systemeio/util'

export const useSettingsMenuItemsFilter = () => {
  const { isLoading: isUserLoading } = useUser()
  const { showChangePasswordPage } = useShowChangePasswordPage()

  const shouldDisplayMenuItem = (item: SettingsMenuEnum) => {
    if (isUserLoading) return true

    switch (item) {
      case SettingsMenuEnum.affiliate_commissions:
      case SettingsMenuEnum.affiliate_program:
      case SettingsMenuEnum.public_api:
      case SettingsMenuEnum.webhooks:
      case SettingsMenuEnum.workspace_members: {
        return isSioHost(window.location.host)
      }
      case SettingsMenuEnum.change_password: {
        return showChangePasswordPage
      }
      default: {
        return true
      }
    }
  }

  const filterMenuItems = (items: SettingsMenuEnum[]) => {
    return items.filter(shouldDisplayMenuItem)
  }

  return {
    filterMenuItems,
  }
}
